import AccidentSearchApplicantStep from './components/AccidentSearchApplicantStep';
import AccidentPersonalInformationStep from './components/AccidentPersonalInformationStep';
import AccidentInfoStep from './components/AccidentInfoStep';
import AccidentCompensationStep from './components/AccidentCompensationStep';
import AccidentAttachmentsStep from './components/AccidentAttachmentsStep';
import AccidentConclusionStep from './components/AccidentConclusionStep';

export default [
  {
    step: 1,
    n: 1,
    id: 'searchApplicant',
    label: 'claim.searchApplicant',
    claimForm: 'accidentClaim',
    iconName: 'search',
    icon: null,
    content: AccidentSearchApplicantStep,
  },
  {
    step: 2,
    n: 2,
    id: 'personalData',
    label: 'claim.personalDataTitle',
    claimForm: 'accidentClaim',
    iconName: 'user',
    icon: null,
    content: AccidentPersonalInformationStep,
  },
  {
    step: 3,
    n: 3,
    id: 'accidentInfo',
    label: 'claim.accInfoTitle',
    claimForm: 'accidentClaim',
    iconName: 'info',
    icon: null,
    content: AccidentInfoStep,
  },
  {
    step: 4,
    n: 4,
    id: 'compensation',
    label: 'claim.compensationTitle',
    claimForm: 'accidentClaim',
    iconName: 'credit card',
    icon: null,
    content: AccidentCompensationStep,
  },
  {
    step: 5,
    n: 5,
    id: 'attachments',
    label: 'claim.attachmentsTitle',
    claimForm: 'accidentClaim',
    iconName: 'cloud upload',
    icon: null,
    content: AccidentAttachmentsStep,
  },
  {
    step: 6,
    n: 6,
    id: 'conclusion',
    label: 'claim.conclusionTitle',
    claimForm: 'accidentClaim',
    iconName: 'clipboard check',
    icon: null,
    content: AccidentConclusionStep,
  },
];
